import { render } from "./ButhiWarnModal.vue?vue&type=template&id=c85b908a&scoped=true"
import script from "./ButhiWarnModal.vue?vue&type=script&lang=js"
export * from "./ButhiWarnModal.vue?vue&type=script&lang=js"

import "./ButhiWarnModal.vue?vue&type=style&index=0&id=c85b908a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wkphi\\Desktop\\Programming\\buthigame - Copy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85b908a"]])

export default __exports__